import './assets/main.css'

import { createApp } from 'vue'
import { createPinia } from 'pinia'
import * as Sentry from '@sentry/vue'

import App from './App.vue'
import router from './router'
import { performStorageCheck, enableStorageMonitoring } from './utils/storageSecurityCheck'

const app = createApp(App)

// Initialize Sentry (conditionally if DSN is provided)
if (import.meta.env.VITE_SENTRY_DSN) {
  Sentry.init({
    app,
    dsn: import.meta.env.VITE_SENTRY_DSN,
    environment: import.meta.env.MODE,
    release: import.meta.env.VITE_APP_VERSION || 'dev',
    // Optional PII sending (off by default; enable via env if needed)
    sendDefaultPii: (import.meta.env.VITE_SENTRY_SEND_DEFAULT_PII === 'true'),
    integrations: [
      Sentry.browserTracingIntegration({ router })
    ],
    tracesSampleRate: import.meta.env.DEV ? 0.1 : 0.2,
    // Enable SDK logs only in development
    _experiments: import.meta.env.DEV ? { enableLogs: true } : undefined
  })
}

app.use(createPinia())
app.use(router)

// Security: Verify no tokens are stored in localStorage/sessionStorage
performStorageCheck()

// Development: Enable continuous monitoring
if (import.meta.env.DEV) {
  enableStorageMonitoring(10000) // Check every 10 seconds
}

app.mount('#app')
